/* @flow strict */

/* eslint-disable camelcase */

import moment from 'moment';
import React from 'react';
import { DefaultContainerContext } from '/client/src/contexts/defaultContainer';
import { emailRegexp } from '/client/src/constants';
import { PUT } from '/client/src/api';
import CssPinner from '/client/src/components/csspinner';
import { EventDetailContainerContext } from '/client/src/contexts/EventDetailContainer';
import { convertToLocalTime } from '/client/src/utils/jstz';

export const columns = (
  editRow: {} | null,
  toggleEdit: ({} | null) => void,
  onHandleFindAndReplaceRowData: () => void
): [] => {
  const style = {
    // background: '#cecece',
    border: '1px solid #cecece',
    borderRadius: '4px',
    lineHeight: '28px',
    padding: '0 .5rem',
    zIndex: 2
  };
  const context = React.useContext(DefaultContainerContext);
  const eventContext = React.useContext(EventDetailContainerContext);
  const time_zone_id = _.get(eventContext, 'eventDetail.time_zone_id', '');

  return [
    {
      selector: '',
      name: '',
      sortable: false,
      cell: (row: {}): React.Element => {
        return (
          <span className={editRow && _.toString(row.id) === _.toString(_.get(editRow, 'id', 0)) ? '' : 'showOnHover'}>
            {(!editRow && _.toString(row.id) !== _.toString(_.get(editRow, 'id', 0))) ?
              <i
                className="icon icon-pencil"
                style={{
                  color: '#e22853',
                  fontSize: '16px'
                }}
                onClick={() => {
                  toggleEdit(row);
                }}
              /> :
              <i
                className="icon icon-save"
                style={{
                  color: '#e22853',
                  fontSize: '16px'
                }}
                onClick={async () => {
                  if (!emailRegexp.test(editRow.email_address)) {
                    context.handleShowSystemDialog(true, {
                      systemDialogType: 'error',
                      systemDialogTitle: 'Oops',
                      systemDialogContent: 'Please enter a proper email address.'
                    });
                  } else {
                    CssPinner(document.body, true);

                    await PUT(`/api/v1/1/events/${row.event_id}/attendee/${row.id}`, {
                      email_address: editRow.email_address,
                      first_name: editRow.first_name,
                      last_name: editRow.last_name
                    });

                    CssPinner(document.body, false);
                    toggleEdit(null);
                  }
                }}
              />
            }
          </span>
        );
      }
    },
    {
      selector: 'first_name',
      name: 'First Name',
      sortable: true,
      cell: (row: {}): React.Element<'div'> => {
        const [fName, setFName] = React.useState(row.first_name);

        if (editRow && _.toString(row.id) === _.toString(_.get(editRow, 'id', 0))) {
          return (
            <input
              type="text"
              value={fName}
              style={style}
              onBlur={() => {
                onHandleFindAndReplaceRowData(row, {
                  first_name: fName,
                  last_name: row.last_name,
                  email_address: row.email_address
                });
              }}
              onChange={(e: any) => {
                setFName(e.target.value);
              }}
            />
          );
        }

        return fName;
      }
    },
    {
      selector: 'last_name',
      name: 'Last Name',
      sortable: true,
      cell: (row: {}): React.Element<'div'> => {
        const [lName, setLName] = React.useState(row.last_name);

        if (editRow && _.toString(row.id) === _.toString(_.get(editRow, 'id', 0))) {
          return (
          <input
            type="text"
            value={lName}
            style={style}
            onBlur={() => {
            onHandleFindAndReplaceRowData(row, {
              first_name: row.first_name,
              last_name: lName,
              email_address: row.email_address
            });
          }}
            onChange={(e: any) => {
            setLName(e.target.value);
          }}
          />
          );
      }
      return lName;
      }
    },
    {
      selector: 'order.creation_time',
      name: 'Date Purchased',
      sortable: true,
      cell: (row: {}): React.Element<'div'> => {
      return convertToLocalTime(_.get(row, 'order.creation_time', ''), time_zone_id, 'MM/DD/YY h:mm a z');
      }
    },
    {
      selector: 'email_address',
      name: 'Email',
      sortable: true,
      cell: (row: {}): React.Element<'div'> => {
        const [email, setEmail] = React.useState(row.email_address);

        if (editRow && _.toString(row.id) === _.toString(_.get(editRow, 'id', 0))) {
          return (
          <input
            type="email"
            value={email}
            style={style}
            onBlur={() => {
            onHandleFindAndReplaceRowData(row, {
              first_name: row.first_name,
              last_name: row.last_name,
              email_address: email
            });
          }}
            onChange={(e: any) => {
            setEmail(e.target.value);
          }}
          />
          );
      }
      return email;
      }
    },
    {
      selector: 'phone_number',
      name: 'Phone',
      sortable: true
    }
    // {
    //     selector: 'ticketType',
    //     name: 'Ticket Type',
    //     sortable: true
    // },
    // {
    //     selector: 'netPay',
    //     name: 'Net Payments',
    //     sortable: true
    // }
  ];
};

// export const data = [
//   {
//     fname: 'tickets test',
//     lname: 'tickets test',
//     datePurch: 'tickets test',
//     email: 'tickets test',
//     phone: 'tickets test',
//     netPay: 'tickets test',
//     ticketType: 'ticketType'
//   },
//   {
//     fname: '2 tickets test',
//     lname: '2 tickets test',
//     datePurch: '2 tickets test',
//     email: '2 tickets test',
//     phone: '2 tickets test',
//     netPay: '2 tickets test',
//     ticketType: '2 ticketType'
//   }
// ];
